// Loading messages configuration for project creation
export const loadingMessages = {
  textAd: {
    brandPhase: [
      "Analyzing your brand voice and messaging framework...",
      "Building your brand architecture from {dataSource}...",
      "Extracting key brand differentiators and positioning...",
      "Mapping your brand's tone, values, and unique selling points..."
    ],
    copyPhase: [
      "Crafting {goal}-focused copy for {platform}...",
      "Generating high-performing ad variations optimized for {goal}...",
      "Writing compelling {adFormat} that align with your brand voice...",
      "Creating {templateCount} ad copy variations designed to drive {goal}...",
      "Applying proven {platform} ad frameworks to your brand messaging..."
    ]
  },
  imageAd: {
    brandPhase: [
      "Analyzing your brand's visual identity and messaging...",
      "Extracting brand colors, fonts, and design elements from your website...",
      "Building a comprehensive brand architecture for consistent visuals...",
      "Mapping your brand's tone, values, and unique selling points..."
    ],
    templatePhase: [
      "Designing multiple ad templates optimized for {platform}...",
      "Creating {templateCount} professional design variations for you to choose from...",
      "Generating layouts that highlight your key messaging and visual identity...",
      "Crafting templates following {platform} best practices..."
    ],
    copyPhase: [
      "Writing {goal}-focused copy for your visual ads...",
      "Pairing compelling headlines with eye-catching designs...",
      "Optimizing text placement and visual hierarchy for maximum impact...",
      "Combining your brand voice with {goal}-optimized design layouts..."
    ]
  }
};

// Helper function to get a random message from an array
export const getRandomMessage = (messages) => {
  return messages[Math.floor(Math.random() * messages.length)];
};

// Helper function to replace placeholders with dynamic values
export const formatMessage = (message, variables) => {
  let formattedMessage = message;

  Object.keys(variables).forEach((key) => {
    const placeholder = `{${key}}`;
    formattedMessage = formattedMessage.replace(placeholder, variables[key]);
  });

  return formattedMessage;
};

// Get formatted messages for the loading sequence
export const getLoadingSequence = (adType, projectData) => {
  const messages = loadingMessages[adType];
  const sequence = [];

  // Prepare dynamic variables
  const variables = {
    dataSource: projectData.websiteUrl ? "your website" : "uploaded materials",
    platform: projectData.platformName || "social media",
    goal: projectData.goal || "engagement",
    adFormat: adType === "textAd" ? "headlines and descriptions" : "visual ads",
    templateCount: projectData.templateCount || "5-8"
  };

  // Brand Phase (always first)
  const brandMessage = getRandomMessage(messages.brandPhase);
  sequence.push({
    phase: "brand",
    message: formatMessage(brandMessage, variables),
    duration: 4000 // 4 seconds
  });

  // Template Phase (only for image ads)
  if (adType === "imageAd") {
    const templateMessage = getRandomMessage(messages.templatePhase);
    sequence.push({
      phase: "template",
      message: formatMessage(templateMessage, variables),
      duration: 5000 // 5 seconds
    });
  }

  // Copy Phase (always last)
  const copyMessage = getRandomMessage(messages.copyPhase);
  sequence.push({
    phase: "copy",
    message: formatMessage(copyMessage, variables),
    duration: 6000 // 6 seconds
  });

  return sequence;
};
